export interface AmplitudeEvents {
  // When a user applies filters to find workouts
  workout_filtered: {
    filters_applied: Record<string, any>;
    results_count: number;
  };

  // When a user changes a movement in a workout
  exercise_swapped: {
    workout_name: string;
    workout_id: string;
    exercise_from: string;
    exercise_to: string;
  };

  // When the "Open whiteboard" button is pressed (coach view)
  whiteboard_opened: {
    workout_id: string;
    workout_name: string;
    is_challenge?: boolean;
  };

  // When the whiteboard is opened in athlete view
  whiteboard_athlete_view_opened: {
    workout_id: string;
    workout_name: string;
  };

  // When a user changes the language of the app
  language_changed: {
    from_lang: string;
    to_lang: string;
  };

  // When a resource file is viewed or downloaded
  resource_viewed: {
    resource_type: string;
    resource_id: string;
    resource_title: string;
    from_challenge?: boolean;
  };

  // When the library page is opened
  library_opened: {
    source: string;
  };

  // When a collection is viewed
  collection_viewed: {
    collection_id: string;
  };

  // When a collection is filtered
  collection_filtered: {
    filters_applied: Record<string, any>;
    results_count: number;
    collection_id: string;
  };

  // When a challenge page is opened
  challenge_opened: {
    challenge_id: string;
    challenge_title: string;
  };

  // When a banner is clicked
  banner_clicked: {
    banner_id: string;
    banner_title: string;
    banner_description: string;
    banner_image_url: string;
    banner_mobile_image_url?: string;
    banner_link_url?: string;
    banner_position: number;
  };

  // When the start plan banner is clicked
  start_plan_banner_clicked: {
    plan_id: string;
    plan_title: string;
  };

  // When the start plan CTA is clicked
  start_plan_cta_clicked: {
    plan_id: string;
    plan_title: string;
  };

  // When the active plan card is clicked
  active_plan_card_clicked: {
    plan_instance_id: string;
    plan_title: string;
    location: PlanTrackingLocation;
  };

  // When a resource video is played within a training plan
  plan_video_played: {
    plan_id: string;
    plan_title: string;
    plan_block_id?: string;
    video_title: string;
    video_id?: number;
    location: PlanTrackingLocation;
  };

  // When a workout card associated with a plan is clicked
  plan_workout_card_clicked: {
    plan_id: string;
    plan_title: string;
    lesson_id: string;
    lesson_title: string;
  };

  // When the end plan CTA is clicked
  end_plan_cta_clicked: {
    plan_id: string;
    plan_title: string;
    plan_instance_id: string;
  };
}

export type AmplitudeEventName = keyof AmplitudeEvents;

export type AvailableProperties<K extends AmplitudeEventName> = AmplitudeEvents[K];

export enum UserProperties {
  PREFERRED_LANGUAGE = 'preferredLanguage',
}

export enum PlanTrackingLocation {
  HOMESCREEN = 'homescreen',
  LIBRARY = 'library',
  PLAN_PREVIEW = 'plan_preview',
  PLAN_INSTANCE = 'plan_instance',
  UNKNOWN = 'unknown',
}
